import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TTaxAndReportingOnboarding } from './tax-and-reporting.types';

type UseTaxAndReportingOnboardingsResponse = {
  taxAndAccountingOnboardings: TTaxAndReportingOnboarding[];
};

function useTaxAndReportingOnboardings(corporationIds: number[]) {
  const query = new URLSearchParams();
  query.append('corporationIds', corporationIds?.map(String).join(','));

  const { data, error, isLoading } = useSWR<UseTaxAndReportingOnboardingsResponse>(
    corporationIds.length > 0
      ? `tax-and-accounting/onboarding/list?${query}`
      : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.taxAndAccountingOnboardings,
    error,
    isLoading: isLoading ?? false,
  };
}

export { useTaxAndReportingOnboardings };
